function VerifyHrefContent(params) {
  // 創建一個新的 URLSearchParams 來保存驗證後的參數
  const sanitizedParams = new URLSearchParams();

  // 迭代所有參數並進行驗證
  for (const [key, value] of params) {
    // 檢查鍵和值是否包含合法字符
    if (IsValidInput(key) && IsValidInput(value)) {
      // 將合法的參數加入到驗證後的參數中
      sanitizedParams.append(key, value);
    }
  }

  return sanitizedParams;
}

// 驗證輸入是否包含合法字符
function IsValidInput(input) {
  // 排除特定字符，允許英文日文中文等其他符號，for路標名稱
  const disallowedCharsRegex = /[<>\"']/;
  return !disallowedCharsRegex.test(input);
}

let fetchData = {
  ReportItem: "",
  ReportValue: 0,
  ReportStartDate: "",
  ReportEndDate: "",
  PageNumber: 1,
  PageSize: 5,
};

$(document).ready(() => {
  customCalendar();
  if (mobileMediaQuery.matches) {
    $(".calendar_input").attr("placeholder", "起 - 迄");
    $(".declaration_amt").attr("placeholder", "半形數字可含小數點");
  }
  $(".icon").click(function () {
    $(this).prev("input").trigger("click");
  });

  $(".calendar_icon").click(function () {
    let open = $(this).hasClass("open");
    if (open) {
      $(this).removeClass("open");
      $(this).next(".calendar").slideUp();
    } else {
      $(this).addClass("open");
      $(this).next(".calendar").slideDown();
    }
  });
  let selected_start = fetchData.ReportStartDate;
  let selected_end = fetchData.ReportEndDate;
  $("input").each(function () {
    if ($(this).hasClass("declaration_amt")) {
      $(this).val(0);
    } else {
      $(this).val("");
    }
  });
  $(".calendar").delegate("table td>button", "click", function (e) {
    let type = $(this).parents(".calendar_input").children("input").data("type");
    let value = $(this).parent("td").data("date");
    let selectedValue = fetchData[type] ? "" : value;
    $(this).parents(".calendar").slideUp(100);
    $(this).parents(".calendar").removeClass("open");
    fetchData[type] = selectedValue;
    $(this).parents(".calendar_input").children("input").val(selectedValue);
    if (type === "ReportStartDate") {
      customCalendar(selectedValue, fetchData.ReportEndDate ? fetchData.ReportEndDate : "", selectedValue);
    }
  });
});

$("input").on("keyup", function () {
  let id = $(this).attr("id");
  let val = $(this).val();
  if (id) fetchData[id] = val;
});
$(".clear_btn").click(function () {
  fetchData.ReportStartDate = "";
  fetchData.ReportEndDate = "";
  fetchData.ReportItem = "";
  fetchData.ReportValue = 0;
  $(".calendar_input").children("input").val("");
  $("#ReportItem").val("");
  $("#ReportValue").val(0);
});
$(".input_calendar_range .input").change(function (e) {
  let type = $(this).data("type");
  if (type) {
    fetchData[type] = e.target.value;
  }
});
$(".search_submit").click(function () {
  fetchData.ReportItem = $("#ReportItem").val();
  if (fetchData.ReportItem === "") {
    $(".modal_notification .title").text("請輸入污染物名稱或代碼");
    $(".modal_notification").fadeIn();
    $(".modal_notification").css("display", "flex");
  } else {
    if (fetchData.ReportValue === "") {
      $(".modal_notification .title").text("請輸入申報量");
      $(".modal_notification").fadeIn();
      $(".modal_notification").css("display", "flex");
    } else {
      if (isNaN(parseFloat(fetchData.ReportValue))) {
        $(".modal_notification .title").text("申報量欄位僅接受半形數字輸入，可包含小數點。請勿使用中文字符，請重新輸入。");
        $(".modal_notification").fadeIn();
        $(".modal_notification").css("display", "flex");
      } else {
        if (fetchData.ReportStartDate === "") {
          $(".modal_notification .title").text("請輸入申報日期");
          $(".modal_notification").fadeIn();
          $(".modal_notification").css("display", "flex");
        } else {
          let link = "";
          for (let i in fetchData) {
            if (i === "PageSize") {
              link += `${i}=${fetchData[i]}`;
            } else {
              link += `${i}=${fetchData[i]}&`;
            }
          }
          const sanitizedParams = VerifyHrefContent(new URLSearchParams(link));

          localStorage.removeItem("selected_items");
          window.location.href = `./info.html?type=3&${sanitizedParams.toString()}`;
        }
      }
    }
  }
});
